import { render, staticRenderFns } from "./UserPermissionUserCount.vue?vue&type=template&id=20c4de39"
import script from "./UserPermissionUserCount.vue?vue&type=script&lang=js"
export * from "./UserPermissionUserCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports